import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./Subscription.module.css";
import "../../../assets/css/notModule.css";
import moment from "moment";
import { Card, CardContent, Chip, Button, Typography } from "@mui/material";
import MyTableBody from "../../../components/subscriptionList";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  MY_SUBS,
  MY_SUBSCRIPTION,
  MY_SUBS_AVAIL,
  PAYMENT_SUCCESS,
  RENEW_SUBS,
  SUBSCRIPTION_LIST,
  CANCEL_SUBSCRIPTION,
} from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "./ConfirmationModal";
import loadRazorpayScript from "../../../utilities/loadRazorpay";
import { toast } from "react-toastify";
import { useRazorpaySubscriptionCheckout } from "../../../hooks/useRazorpaySubscriptionCheckout";

// Opening the Razorpay autopay checkout writes a "pending" row with no dates
// before the sheet opens; backing out leaves it behind. It isn't a purchase,
// and moment(undefined) is "now", so it showed as an unassigned plan expiring
// today with a Cancel Auto-Renew button. Rows from before payment_status
// existed are real purchases and are recognised by having an end_date.
// The backend now filters these too; this covers an older API.
const isPurchased = (sub) => {
  const status = sub.payment_status;
  if (status === undefined || status === null) return Boolean(sub.end_date);
  return status === "completed";
};

const SubscriptionsHome = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [availSubscription, setAvailSubscription] = useState();
  const [subscriptionList, setSubsciptionList] = useState();
  const [fullSubscList, setFullSubscList] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [success, setSuccess] = useState(false);
  // const availbleSubs = useSelector(
  //   (state) => state.teams.availbleSubs
  // );
  const ln = useSelector((state) => state.allUsers.language_json);
  const { startRecurringCheckout } = useRazorpaySubscriptionCheckout();
  const renderCount = useRef(0);
  renderCount.current += 1;
  console.debug(
    `[DEBUG] render #${renderCount.current} — subscriptionList:`,
    subscriptionList?.length ?? "undefined",
    "ln:",
    !!ln,
    "fullSubscList:",
    fullSubscList?.length,
  );

  React.useEffect(() => {
    console.debug("[DEBUG] language effect fired — ln:", ln);
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubscriptionListData = async () => {
    console.debug("[DEBUG] getSubscriptionListData called");
    console.trace("[DEBUG] getSubscriptionListData call stack");
    try {
      const { data } = await authApi.get(`${MY_SUBS}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      console.debug("[DEBUG] MY_SUBS response length:", data?.length);
      const purchased = (data || []).filter(isPurchased);
      setFullSubscList(purchased);
      // data is sorted newest-first; keep one card per team (the latest), plus all unassigned
      const seenTeams = new Set();
      const filterArray = purchased.filter((item) => {
        if (new Date(item.start_date) > new Date()) return false;
        const teamKey = String(item.teams?.[0]?._id || "");
        if (!teamKey) return true;
        if (seenTeams.has(teamKey)) return false;
        seenTeams.add(teamKey);
        return true;
      });
      console.debug(
        "[DEBUG] filtered subscriptionList length:",
        filterArray?.length,
      );
      setSubsciptionList(filterArray);
      if (data) {
        getMergedData();
      }
    } catch (error) {
      console.error("[DEBUG] getSubscriptionListData error:", error);
    }
  };

  const getAllPlans = async () => {
    try {
      const { data } = await authApi.get(SUBSCRIPTION_LIST, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setAllPlans(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getPlanName = (item) => {
    if (item.subscription_details?.packageName)
      return item.subscription_details.packageName;
    if (item.subscription_details?.plan_name)
      return item.subscription_details.plan_name;

    const plan = allPlans.find(
      (p) => String(p._id) === String(item.subscription_id),
    );
    return plan ? plan.packageName : item.packageName || "Plan";
  };

  const getMergedData = () => {};

  const getTeamKey = (item) => String(item.teams?.[0]?._id || "");

  const getExpiryDate = (item) => {
    const teamKey = getTeamKey(item);
    if (!teamKey) return moment(item.end_date).format("DD MMM YYYY");
    const filteredArray = fullSubscList.filter(
      (item2) => getTeamKey(item2) === teamKey,
    );
    // fullSubscList is sorted newest-first; use index 0 for the latest expiry
    return moment(filteredArray[0].end_date).format("DD MMM YYYY");
  };

  const claculateRemaining = (item) => {
    const teamKey = getTeamKey(item);
    if (!teamKey) return moment(item.end_date).diff(moment(), "days");
    const filteredArray = fullSubscList.filter(
      (item2) => getTeamKey(item2) === teamKey,
    );
    // fullSubscList is sorted newest-first; use index 0 for the latest expiry
    const expiryDate = moment(filteredArray[0].end_date);
    return expiryDate.diff(moment(), "days");
  };

  const checkRenew = (item) => {
    const teamKey = getTeamKey(item);
    if (!teamKey) return false;
    const filteredArray = fullSubscList.filter(
      (item2) => getTeamKey(item2) === teamKey && item2._id !== item._id,
    );
    return filteredArray.length > 0;
  };
  useEffect(() => {
    getSubscriptionListData();
    getAllPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubsription = async () => {
    var result = {};
    await authApi
      .get(MY_SUBS_AVAIL, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then(function (res) {
        //dispatch(SaveAvailableSubc(res.data));
        result = res.data[res.data?.length - 1];
      });
    return result;
  };

  useEffect(() => {
    console.debug(
      "[DEBUG] subscriptionList changed, length:",
      subscriptionList?.length ?? "undefined",
    );
  }, [subscriptionList]);

  const handlePaymentButton = async (item, type) => {
    try {
      // Durations backfilled with a Razorpay plan support real auto-debit;
      // anything else falls back to the legacy one-time-payment flow below.
      const plan = allPlans.find(
        (p) => String(p._id) === String(item.subscription_id),
      );
      const matchingDuration = plan?.durations?.find(
        (d) => String(d._id) === String(item.duration_details?._id),
      );

      if (matchingDuration?.razorpay_plan_id) {
        await startRecurringCheckout({
          subscriptionId: item.subscription_id,
          durationId: item.duration_details._id,
          customerSubId: item._id,
          description: "TeamPlayer Subscription",
          onAuthorized: async () => {
            await handleRenew(item, type);
          },
        });
        return;
      }

      const res = await loadRazorpayScript(
        "https://checkout.razorpay.com/v1/checkout.js",
      );
      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }

      // Create the order first, so the server can price the checkout from
      // it and the payment can be confirmed against it.
      const { data: selected } = await authApi.post(
        MY_SUBSCRIPTION,
        {
          subscriptionid: item.subscription_id,
          durationid: item.duration_details._id,
          type: type,
          team_id: item.teams?.[0]?._id,
        },
        { headers: { Authorization: getAuthorizationHeader() } },
      );
      const dbOrder = selected?.data;
      if (!dbOrder?._id) {
        toast.error("Unable to create order. Please try again.");
        return;
      }

      const basePrice = parseFloat(item?.duration_details?.price?.$numberDecimal || 0);
      const totalWithGst =
        dbOrder.order_payable ?? Number((basePrice * 1.18).toFixed(2));
      const { data } = await authApi.post("/my-subscriptions/create-order", {
        amount: totalWithGst,
        currency: "INR",
        receipt: `receipt_${dbOrder._id}`,
        order_id: dbOrder._id,
      });
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.order.amount,
        currency: data.order.currency,
        name: "Team Player App",
        description: "Payment for subscription",
        order_id: data.order.id,
        handler: async (response) => {
          const verifyRes = await authApi.post(
            "/my-subscriptions/verify-order",
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            },
          );

          if (verifyRes.data.success) {
            await handleRenew(item, type, {
              order: dbOrder,
              paymentDetails: {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              },
            });
          } else {
            alert("Payment Verification Failed.");
          }
        },
        theme: {
          color: "#528FF0",
        },
        modal: {
          ondismiss: () => {
            toast.error("Payment Cancelled!");
          },
        },
      };

      const rzp = new window.Razorpay(options);

      // 🔴 Handle payment failure explicitly
      rzp.on("payment.failed", function (response) {
        console.error("Payment failed:", response);
        alert("Payment Failed!\nReason: " + response.error.description);
      });

      rzp.open();
    } catch (error) {
      console.log("Payment Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };
  // `paid` carries the order and Razorpay proof when this follows a one-time
  // checkout; the server refuses to activate a paid order without them.
  const handleRenew = async (item, type, paid = {}) => {
    let order = paid.order;
    if (!order) {
      const userEntry = {
        subscriptionid: item.subscription_id,
        durationid: item.duration_details._id,
        type: type,
      };
      const { data } = await authApi.post(MY_SUBSCRIPTION, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      order = data?.data;
    }
    if (order) {
      const userEntry2 = {
        userid: order.user_id,
        orderid: order._id,
        type: type,
        ...(paid.paymentDetails ? { payment_details: paid.paymentDetails } : {}),
      };
      const data2 = await authApi.post(PAYMENT_SUCCESS, userEntry2, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      // Use the customerSubscriptionId returned directly from paymentSuccess
      const newSubId = data2.data?.customerSubscriptionId;
      if (data2.data && newSubId) {
        await authApi.post(
          RENEW_SUBS,
          {
            team_id: item.teams[0]?._id,
            avail: { _id: newSubId },
            type: "renew",
          },
          {
            headers: { Authorization: getAuthorizationHeader() },
          },
        );
        setSuccess(true);
      } else if (data2.data) {
        // Fallback: fetch available subscriptions and use the most recent (sorted by backend)
        const availsubs = await getSubsription();
        if (availsubs) {
          const userEntry3 = {
            team_id: item.teams[0]?._id,
            avail: availsubs,
            type: "renew",
          };
          await authApi.post(RENEW_SUBS, userEntry3, {
            headers: { Authorization: getAuthorizationHeader() },
          });
          setSuccess(true);
        }
      }
    }
  };

  const handleCancelSubscription = async (item) => {
    if (!window.confirm("Cancel auto-renewal for this subscription? You'll keep access until it expires, but it won't be charged again.")) {
      return;
    }
    try {
      await authApi.post(
        CANCEL_SUBSCRIPTION,
        { customer_sub_id: item._id, cancel_at_cycle_end: true },
        { headers: { Authorization: getAuthorizationHeader() } },
      );
      toast.success("Subscription cancelled. It won't auto-renew.");
      getSubscriptionListData();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to cancel subscription");
    }
  };

  const handleUpgradePlan = async (item) => {
    if (item && item.teams && item.teams?.length > 0) {
      sessionStorage.setItem("team_id", item.teams[0]._id);
    }
    navigate(`/upgrade-plan/${item._id}`);
  };

  const getTotalDuration = (item) => {
    const filteredArray = fullSubscList.filter(
      (item2) => item2.team_id === item.team_id,
    );
    let days = 0;
    if (filteredArray && filteredArray?.length > 0) {
      // eslint-disable-next-line array-callback-return
      filteredArray.map((item2) => {
        days += item2.duration;
      });
    }
    return days;
  };

  const closeModal = () => {
    setSuccess(false);
    getSubscriptionListData();
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow:
      subscriptionList && subscriptionList?.length < 3
        ? subscriptionList?.length
        : 3,
    slidesToScroll: 2,
    customPaging: () => <div className={"customDots"} />, // Custom dot element using CSS module class
    prevArrow: <></>, // Empty arrow component to hide previous button
    nextArrow: <></>, // Empty arrow component to hide next button
    //customPaging: () => <div className="custom-dot" />,
  };

  return (
    <div className={classes.SubscriptionMainDiv}>
      {ln && subscriptionList && subscriptionList?.length > 0 ? (
        <div>
          <Typography className={classes.subscSubHeading}>
            {ln.teams}
          </Typography>
          <Slider
            {...settings}
            className={
              subscriptionList?.length < 3 ? classes.sliderMaindiv : ""
            }
          >
            {subscriptionList.map((item, index) => {
              // console.log(item);
              return (
                <div key={index} className={classes.EachSubscriptionCard}>
                  <Card
                    key={item._id}
                    className={classes.teamCard}
                    //onClick={(e) => handleCardClick(e, item)}
                  >
                    <CardContent sx={{ paddingBottom: "16px !important" }}>
                      <div className={classes.cardHeaderContainer}>
                        <div className={classes.memberCardText}>
                          <h5 style={{ marginBottom: 0 }}>
                            {item.teams && item.teams?.length > 0
                              ? item.teams[0].team_name
                              : "Available Subscription"}
                          </h5>
                        </div>
                        {parseFloat(
                          item.duration_details.price?.$numberDecimal,
                        ) === 0 ? (
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            <Chip
                              label="Free"
                              size="small"
                              sx={{
                                backgroundColor: "#e6f4ea",
                                color: "#2e7d32",
                                fontWeight: 600,
                                fontSize: "12px",
                                height: "24px",
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-end",
                              gap: "4px",
                            }}
                          >
                            <div>
                              <span className={classes.AmountText}>
                                ₹ {item.duration_details.price.$numberDecimal}
                              </span>
                              /
                              <span
                                style={{
                                  fontSize: "12px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {ln[item.duration_details.duration] ||
                                  item.duration_details.duration}
                              </span>
                            </div>
                            <div style={{ fontSize: "11px", color: "#6B7280" }}>
                              excl. 18% GST
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className={classes.memberCardText}
                        style={{ marginTop: "4px" }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "#6b778c",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {getPlanName(item)} (
                          {ln[item.duration_details.duration] ||
                            item.duration_details.duration}
                          )
                        </Typography>
                      </div>
                      <div className={classes.PiechartContainerMain}>
                        <div className={classes.piechartSvgContainer}>
                          {(() => {
                            const remaining = Math.max(
                              0,
                              claculateRemaining(item),
                            );
                            const total = getTotalDuration(item);
                            const remainingPct =
                              total > 0 ? (remaining / total) * 100 : 0;
                            const elapsedPct = 100 - remainingPct;
                            return (
                              <svg
                                aria-hidden="true"
                                focusable="false"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 44 44"
                                className={classes.piechartSvg}
                              >
                                <circle
                                  cx="50%"
                                  cy="50%"
                                  fill="transparent"
                                  r="15.909091"
                                  stroke="#eee"
                                  strokeWidth={10}
                                />
                                <circle
                                  cx="50%"
                                  cy="50%"
                                  fill="transparent"
                                  r="15.909091"
                                  stroke="#C52A38"
                                  strokeDasharray={`${elapsedPct} ${remainingPct}`}
                                  strokeWidth={10}
                                  strokeDashoffset={0}
                                />
                                <circle
                                  cx="50%"
                                  cy="50%"
                                  fill="transparent"
                                  r="15.909091"
                                  stroke="#240051"
                                  strokeDasharray={`${remainingPct} ${elapsedPct}`}
                                  strokeWidth={10}
                                  strokeDashoffset={-elapsedPct}
                                />
                                <circle
                                  cx="50%"
                                  cy="50%"
                                  fill="#FFFFFF"
                                  r={16}
                                />
                                <text
                                  x="50%"
                                  y="55%"
                                  className="ct-donut-center"
                                >
                                  {remaining}
                                </text>
                              </svg>
                            );
                          })()}
                          <div className="ct-tip" />
                        </div>
                        <div className={classes.memberCardText}>
                          <h5 className={classes.ImportantHeading}>
                            {Math.max(0, claculateRemaining(item))} {ln.days}
                          </h5>
                          <p className={classes.ImportantSubHeading}>
                            {ln.remaing} {getTotalDuration(item)} {ln.days}
                          </p>
                        </div>
                      </div>
                      <hr className={classes.UnderlineHr} />
                      <div
                        className={`${classes.memberCardText} ${classes.dateText}`}
                      >
                        <p>
                          {claculateRemaining(item) <= 0
                            ? "Expired On"
                            : ln.expiry_on}{" "}
                          :{" "}
                        </p>
                        <h5 className={classes.ImportantHeading}>
                          {getExpiryDate(item)}
                        </h5>
                      </div>
                      <div className={classes.CardBtnsSection}>
                        {item.teams && item.teams?.length > 0 ? (
                          <Button
                            variant="outlined"
                            className={classes.cardBtn}
                            disabled={
                              item.duration_details.duration === "custom" ||
                              checkRenew(item, index) ||
                              parseFloat(
                                item.duration_details.price.$numberDecimal,
                              ) === 0
                            }
                            onClick={() => {
                              handlePaymentButton(item, "renew");
                            }}
                          >
                            {!checkRenew(item, index)
                              ? ln.renew
                              : "Already Renewed"}
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            className={classes.cardBtn}
                            onClick={() => {
                              navigate("/my-team/create-team");
                            }}
                          >
                            {ln?.create_team}
                          </Button>
                        )}

                        <Button
                          variant="contained"
                          disabled={
                            item.duration_details.duration === "custom" ||
                            checkRenew(item, index) ||
                            !item.teams?.length
                          }
                          className={classes.cardBtn}
                          onClick={() => handleUpgradePlan(item)}
                        >
                          {ln.upgrade_plan}
                        </Button>
                        {item.auto_debit && item.status !== "cancelled" && (
                          <Button
                            variant="text"
                            color="error"
                            className={classes.cardBtn}
                            onClick={() => handleCancelSubscription(item)}
                          >
                            Cancel Auto-Renew
                          </Button>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              );
            })}
          </Slider>
        </div>
      ) : null}
      <div style={{ marginTop: "70px" }}>
        <Typography className={classes.subscSubHeading}>
          {ln?.history}
        </Typography>
        <MyTableBody list={fullSubscList} allPlans={allPlans} />
      </div>
      {success && <ConfirmationModal closeModal={closeModal} />}
    </div>
  );
};

export default SubscriptionsHome;
